import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import styles from './accordion-inline.module.scss.js';
import AccordionInlineItem from './accordion-inline-item.js';

const AccordionInline = ({ surface = 'lightPrimary', items, behavior = 'singleOpen', }) => {
    const firstOpenedIndex = behavior === 'singleOpen' && items
        ? items.findIndex((item) => item.opened === true)
        : undefined;
    const [activeItem, setActiveItem] = useState(behavior === 'singleOpen' && typeof firstOpenedIndex !== 'undefined'
        ? `active-accordion-item-${firstOpenedIndex}`
        : undefined);
    const _renderAccordionItems = () => items &&
        (items === null || items === void 0 ? void 0 : items.map((item, index) => {
            function calcOpenItem() {
                if (behavior === 'singleOpen') {
                    if (item.opened)
                        return index === firstOpenedIndex;
                }
                return item.opened;
            }
            return (jsx(AccordionInlineItem, Object.assign({ id: `active-accordion-item-${index}`, surface: surface, activeItem: behavior === 'singleOpen' && activeItem }, item, { opened: calcOpenItem(), onClick: setActiveItem }), `accordion-item-${index}`));
        }));
    return (jsx("div", { className: styles.accordionInlineWrapper, children: _renderAccordionItems() }));
};

export { AccordionInline as default };
